import { render, staticRenderFns } from "./Icons.vue?vue&type=template&id=2a1f51ca&scoped=true&"
import script from "./Icons.vue?vue&type=script&lang=ts&"
export * from "./Icons.vue?vue&type=script&lang=ts&"
import style0 from "./Icons.vue?vue&type=style&index=0&id=2a1f51ca&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1f51ca",
  null
  
)

export default component.exports